import './onView.css';
import React, { useState, useEffect } from "react";

import { GET_STAKEHOLDER_BY_URN, GET_APPLICATION_COMMENTS, ALLOCATE_WORKFLOW } from '../../../common/URLs';
import { useNavigate, useLocation } from "react-router-dom";
import { ROLES } from '../../../common/constants';
import { Row, Col } from 'react-bootstrap';
import { loaderService } from '../../../common/custom-loader/loader-service';
import { TextField } from '@mui/material';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { VALIDATION } from '../../../common/commonValidations';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';
import { ApproveIcon, CloseIcon, ReportIcon, SubmitIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ViewComments(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  //const userId = location.state.data?.userId;
  const [status, setStatus] = useState();
  const [urn, setUrn] = useState();
  const [roles, setRoles] = useState(localStorage.getItem("role"));
  const [stakeHoldersId, setStakeHoldersId] = useState();
  const [applicationComments, setApplicationComments] = useState();
  const [postApplicationComments, setPostApplicationComments] = useState();
  const [clarificationBtn, setClarificationBtn] = useState();
  const [stakeholderRole, setStakeholderRole] = useState();
  const [stakeholderUserId, setStakeholderUserId] = useState();
  const [createdBy, setcreatedBy] = useState();
  const [registeredBy, setRegisteredBy] = useState();
  const [workflowAction, setWorkflowAction] = useState();
  const [isStakeholder, setIsStakeholder] = useState(false);
  const [scrutinyStatus, setScrutinyStatus] = useState();
  const [currentOwnerID, setCurrentOwnerID] = useState();
  const [loggedInUser, setLoggedInUser] = useState(localStorage.getItem('uuid'));
    const [registrationCompleted, setRegistrationCompleted] = useState(false);
    const [characterLimit] = useState(300);

  const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
  const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
  const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);


  const [details, setDetails] = useState({
    comments: ''

  });
  const [errorMessage, setErrorMessage] = useState({
    commentsError: ""

  })
  const [growerDetails, setGrowerDetails] = useState();
    const handleChange = (e) => {
        var text = e.target.value.slice(0,300);
        setDetails({ ...details, [e.target.name]: VALIDATION.noSpecialCharacterValidation(text) });
  };
  useEffect(() => {
    if (location?.state?.data?.urn) {
      setUrn(location?.state?.data?.urn)
    }
    else if (location?.state?.data?.urnSelected) {
      setUrn(location?.state?.data?.urnSelected)
    }
    setClarificationBtn(location?.state?.data?.submitClarification);
    setcreatedBy(location?.state?.data?.createdBy);
    if (location?.state?.data?.submitClarificationstake) setClarificationBtn(location?.state?.data?.submitClarificationstake)
    if (location?.state?.data?.stakeRole) setStakeholderRole(location?.state?.data?.stakeRole)
  }, []);
  useEffect(() => {
    if (urn) {
      getStakeholderDetailsFromUrn()
    }
  }, [urn]);
  const getStakeholderDetailsFromUrn = () => {
    apiClient.post(GET_STAKEHOLDER_BY_URN,
      {
        "urn": urn,
        "includeRejected": true
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        setGrowerDetails(response.data.stakeHolder);
      })
      .catch(function (error) {
        console.log(error);
      });

  }
  useEffect(() => {
    if (growerDetails) {
      setStakeHoldersId(growerDetails?.id)
      setStatus(growerDetails?.registrationStatus)
      setRegisteredBy(growerDetails?.registrationCompletedBy);
      setCurrentOwnerID(growerDetails?.currentOwnerID)
      setScrutinyStatus(growerDetails?.scrutinyStatus)
      setRegistrationCompleted(growerDetails?.registrationCompleted)
    }
  }, [growerDetails]);

  useEffect(() => {
    if (postApplicationComments) {
      if (postApplicationComments.isSuccess === true) {
        toast.success(postApplicationComments?.message);
        if (loggedInUser)
          navigate('/registrationHome/dashboard');
        else
          navigate('/dashboardHome/dashboardStakeHolder');
      } else {
        toast.error(postApplicationComments?.message)
      }
    }
  }, [postApplicationComments]);

  const onSubmit = () => {
    handleLogModalConfirmClose();
    if (details.comments == "") {
      setErrorMessage({ ...errorMessage, commentsError: "Please enter comment." });

    }
    else {
      setErrorMessage({ ...errorMessage, commentsError: "" });
      var workflowInitiatorID = (isStakeholder == true ? stakeHoldersId : loggedInUser);
      var workflowReceiverID = (workflowAction == "Request_Clarification" ? growerDetails?.registrationCompletedBy : (workflowAction == "Submit_Clarification" && isStakeholder == true ? stakeholderUserId : (workflowAction == "Submit_Clarification" ? createdBy : "")));
      loaderService.showLoader();
      apiClient.post(ALLOCATE_WORKFLOW,
        {
          "stakeHolderMasterID": stakeHoldersId,
          "workflowInitiatorID": workflowInitiatorID,
          "workflowReceiverID": workflowReceiverID,
          "workflowAction": workflowAction,
          "status": "",
          "comments": details.comments,
          "isStakeHolderAction": isStakeholder,
          "workflowInitiatorRole": isStakeholder == true ? "" : localStorage.getItem('role'),
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
        .then((response) => {
          setPostApplicationComments(response.data);
          loaderService.hideLoader();
        })
        .catch(function (error) {
          console.log(error);
          loaderService.hideLoader();

        });
    }
  };
  const confirmSubmission = (e, workflowAction, isStakeholder) => {
    setWorkflowAction(workflowAction);
    setIsStakeholder(isStakeholder);
    handleLogModalConfirmOpen();
  }
  const onSubmitClose = () => {
    if (loggedInUser)
      navigate('/registrationHome/dashboard');
    else
      navigate('/dashboardHome/dashboardStakeHolder');

  }

  useEffect(() => {
    if (stakeHoldersId) {
      getAllApplicationComments();
    }

  }, [stakeHoldersId]);
  function getAllApplicationComments() {
    apiClient
      .post(GET_APPLICATION_COMMENTS,
        {
          "stakeHolderMasterID": stakeHoldersId
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setApplicationComments(response.data);
        setStakeholderUserId(response.data?.comments?.[0]?.userID)

      })
      .catch(function (error) {
      });
  }

  const applicationCommentsArray = applicationComments?.comments;
  const isDisabled = () => {
    if (loggedInUser === growerDetails?.registrationCompletedBy) {
      return true;
    }

    else {
      return false;
    }
  }

  const columns = [
    {
      field: 'createdDate', headerName: t('reg.date'), width: 180,
    },
    { field: 'userName', headerName: t('preReg.name'), width: 210 },
    { field: 'userRole', headerName: t('reg.userRole'), width: 210 },
    { field: 'comment', headerName: t('reg.comments'), width: 210 },

  ];

  return (

    <div>
      <Row>
        <Col xs={12} md={12}>
          <Card>
            <Box style={{ height: 350, width: '100%' }}>
              {
                applicationCommentsArray &&
                <DataGrid
                  sx={{
                    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                  }}
                  getRowHeight={() => 'auto'}
                  rows={applicationCommentsArray}
                  columns={columns}
                  pageSize={10}
                  getRowId={(row) => row.commentID}
                  components={{ Toolbar: QuickSearchToolbar }}
                />
              }

            </Box>
          </Card>
          {(status === "Approved" || status === "Rejected" || growerDetails === null || registrationCompleted === false || (clarificationBtn === "yes" && roles === ROLES.RegInCharge) || (currentOwnerID !== loggedInUser && stakeholderRole !== "Stakeholder")) ? null :
            <div>
              <Row>
                              <Col xs={12} md={8}>
                                  <TextField sx={{ mt: 2 }} rows={4} fullWidth multiline name="comments" label="Add Comment" value={details.comments} onChange={(e) => handleChange(e)}
                                      InputProps={{
                                         maxLength: 300 
                                  }} />
                                  <div style={{ display: 'flex', justifyContent: 'flex-end' , paddingTop:'1vh'}}>
                                      <Badge bg={`${details.comments?.length > characterLimit ? 'danger' : 'primary'}`}>{details.comments?.length}/{characterLimit}</Badge>
                                  </div>
                              </Col>
                <p style={{ color: "red", fontSize: "2.3vh" }}>{errorMessage.commentsError}</p>
                <Col xs={12}>
                  {roles === ROLES.RegInCharge &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                      <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)} startIcon={<ReportIcon/>}>Seek Clarification</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Approve", false)} startIcon={<ApproveIcon/>}>Approve</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Reject", false)} startIcon={<CloseIcon/>}>Reject</Button>
                    </Box>
                  }
                  {roles === ROLES.LeadRegScrutinizer &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                      <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)} startIcon={<ReportIcon/>}>Seek Clarification</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Approve", false)} startIcon={<ApproveIcon/>}>Approve</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Propose Rejection", false)} startIcon={<CloseIcon/>}>Propose Rejection</Button>
                    </Box>
                  }
                  {roles === ROLES.RegistrationScruitnizer && scrutinyStatus == "Pending_Clarification" &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                      <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => confirmSubmission(e, "Submit_Clarification", false)} endIcon={<SubmitIcon/>}>Submit Clarification</Button>
                    </Box>
                  }
                  {roles === ROLES.RegistrationScruitnizer && scrutinyStatus != "Pending_Clarification" &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                      <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)} disabled={isDisabled()} startIcon={<ReportIcon/>}>Seek Clarification</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Approve", false)} startIcon={<ApproveIcon/>}>Approve</Button>
                      <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => confirmSubmission(e, "Propose Rejection", false)} startIcon={<CloseIcon/>}>Propose Rejection</Button>
                    </Box>

                  }
                  {clarificationBtn === "yes" && stakeholderRole === "Stakeholder" &&
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                      <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => confirmSubmission(e, "Submit_Clarification", true)} disabled={isDisabled()} endIcon={<SubmitIcon/>}>Submit Clarification</Button>
                    </Box>
                  }
                  {/*        : roles === ROLES.RegInCharge ? <div><input className="submit_button_shortlist" type="submit" value="Seek Clarification" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)}  style={{display : "none"}} /></div>*/}
                  {/*        : <div> <input className="submit_button_shortlist" type="submit" value="Submit Clarification" onClick={(e) => confirmSubmission(e, "Submit_Clarification", false)} /> </div>*/}
                  {/*        : <div>{roles === ROLES.RegInCharge ? <input className="submit_button_shortlist" type="submit" value="Seek Clarification" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)} />*/}
                  {/*        : <input className="submit_button_shortlist" type="submit" value="Seek Clarification" onClick={(e) => confirmSubmission(e, "Request_Clarification", false)} disabled={isDisabled()} />}*/}
                  {/*          {roles === ROLES.RegInCharge ? <input className="submit_button_shortlist" type="submit" value="Reject" onClick={(e) => confirmSubmission(e, "Reject", false)} />*/}
                  {/*        : roles === ROLES.LeadRegScrutinizer ? <input className="submit_button_shortlist" type="submit" value="Propose Rejection" onClick={(e) => confirmSubmission(e, "Reject", false)} />*/}
                  {/*        : roles === ROLES.RegistrationScruitnizer ? <input className="submit_button_shortlist" type="submit" value="Propose Rejection" onClick={(e) => confirmSubmission(e, "Propose_Rejection", false)} />*/}
                  {/*        : <input className="submit_button_shortlist" type="submit" value="Propose Rejection" onClick={(e) => confirmSubmission(e, "Propose_Rejection", false)} />}*/}
                  {/*         <input className="submit_button_shortlist" type="submit" value="Approve" onClick={(e) => confirmSubmission(e, "Approve", false)} />*/}
                  {/*            </div>}</Row></div>*/}

                  {/*}*/}
                </Col>
              </Row>
            </div>}
        </Col>
      </Row>
          <ConfirmationPopover onOpen={logModalOpenConfirm} action="Submit"  onConfirm={onSubmit} onClose={handleLogModalConfirmClose} />
     </div>
  );

}

export default ViewComments;
